/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-01 17:00:09
 */
/**
 * 会员管理 Saga集合
 */
import member from './member/model';
import microbusinesses from './microbusinesses/model';
import Rider from './rider/model';
import Black from './black/model';
import Agent from './agent/model';

export default [
    ...Object.values(member.sagas), // 会员管理
    ...Object.values(Rider.sagas), // 骑士管理
    ...Object.values(Black.sagas), // 黑名单管理
    ...Object.values(Agent.sagas), // 经纪人管理
    ...Object.values(microbusinesses.sagas), // 微企管理
];
